import React, { Component } from "react";
import styles from "../../assets/css/modules/shared/info-box.css";

export default class InfoBox extends Component {
  render() {
    return (
      <div className={styles.infoBox + " " + this.props.className}>
        {this.props.InfoBoxImage && (
          <img src={this.props.InfoBoxImage} alt="Information" />
        )}
        {this.props.iconClass && (
          <i className={this.props.iconClass + " " + styles.icon} />
        )}
        {this.props.children}
      </div>
    );
  }
}
